import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { Actions } from '../../actions';
import { AttachToRecordLabel } from '../action-creators';
import { CreateArtistSuccess } from '../../artist/action-creators';
import { CREATE_ARTIST_SUCCESS } from '../../artist/actions';
import AppState from '../../state';
import { NoOp } from '../../ui/action-creators';

export const attachNewArtistEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, CreateArtistSuccess>(CREATE_ARTIST_SUCCESS),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.recordLabels.active?.id),
    map(([action, state]) => {
      const label = state.recordLabels.active;

      if (!label) {
        return new NoOp();
      }

      return new AttachToRecordLabel({
        recordLabelId: label.id,
        recordLabelName: label.name as string,
        artistId: action.artist.id,
        artistName: action.artist.name,
        artistAvatar: action.artist.avatar,
      });
    })
  );
